import { render, staticRenderFns } from "./DealerVerifierRegister.vue?vue&type=template&id=4d7a85af"
import script from "./DealerVerifierRegister.vue?vue&type=script&lang=js"
export * from "./DealerVerifierRegister.vue?vue&type=script&lang=js"
import style0 from "./DealerVerifierRegister.vue?vue&type=style&index=0&id=4d7a85af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports